import React, { useEffect } from 'react';
import { TopBannerType } from 'context/ConfiguratorContext/ConfiguratorContext.types';
import useWindowWidth from 'utils/useWindowWidth';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import Timer from '../Timer';
import styles from './HeaderBanner.module.css';

const HeaderBanner = (data: TopBannerType) => {
  const { sendEvent } = useClickStreamEvent();

  const sendClickEvent = () => {
    sendEvent({
      eventType: 'click',
      eventInfo: `otvety_header_banner`,
      customDimentions: {
        cd1: data.name,
      },
    });
  };

  useEffect(() => {
    sendEvent({
      eventType: 'display',
      eventInfo: `otvety_header_banner`,
      customDimentions: {
        cd1: data.name,
      },
    });
  }, []);

  const windowWidth = useWindowWidth();
  const deviceType =
    windowWidth > 1023
      ? 'desktop'
      : windowWidth < 1024 && windowWidth > 767
      ? 'tablet'
      : 'mobile';

  return (
    <a
      href={data.link}
      target="_blank"
      onClick={sendClickEvent}
      className={styles.banner}
      style={{
        backgroundColor: data.background,
      }}
      rel="noopener"
    >
      <div className={styles.wrapper}>
        <div
          className={styles.banner__img}
          style={{
            backgroundImage: `url(${data.images[deviceType]})`,
          }}
        />
        {data?.timer?.endTime && (
          <div className={styles.timer}>
            <Timer timerData={data.timer} />
          </div>
        )}
      </div>
    </a>
  );
};

export default HeaderBanner;
